(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fmn-candle-finder-v2"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fmn-finder]').forEach((finder) => {
    if (finder.dataset.initialized === 'true') return;
    finder.dataset.initialized = 'true';

    const intro = finder.querySelector('[data-intro]');
    const quizShell = finder.querySelector('[data-quiz-shell]');
    const form = finder.querySelector('[data-quiz]');
    const loading = finder.querySelector('[data-loading]');
    const steps = Array.from(finder.querySelectorAll('[data-step]'));
    const results = finder.querySelector('[data-results]');
    const grid = finder.querySelector('[data-result-grid]');
    const resultTemplate = finder.querySelector('[data-result-template]');
    const progressBar = finder.querySelector('[data-progress-bar]');
    const progressText = finder.querySelector('[data-progress-text]');
    const summary = finder.querySelector('[data-results-summary]');
    const emailResultsForm = finder.querySelector('[data-email-results]');
    const emailStatus = finder.querySelector('[data-email-status]');
    const answers = {};
    const answerLabels = {};
    let currentStep = 0;
    let currentMatches = [];

    const track = (eventName, detail = {}) => {
      const payload = { event: `fmn_scent_quiz_${eventName}`, ...detail };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent(payload.event, { detail: payload }));
    };

    const updateProgress = () => {
      const progress = Math.min((currentStep + 1) / steps.length, 1);
      progressBar.style.transform = `scaleX(${progress})`;
      progressText.textContent = `${finder.dataset.progressWord} ${currentStep + 1} ${finder.dataset.progressConnector} ${steps.length}`;
    };

    const transition = (callback) => {
      if (document.startViewTransition) {
        document.startViewTransition(callback);
      } else {
        callback();
      }
    };

    const showStep = (index) => {
      transition(() => {
        steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== index;
        });
        currentStep = index;
        updateProgress();
        steps[index].querySelector('button')?.focus();
      });
    };

    const showResults = () => {
      const relatedTags = {
        spring: ['floral', 'citrus', 'bright'],
        summer: ['citrus', 'bright'],
        fall: ['seasonal', 'warm', 'woodsy'],
        winter: ['seasonal', 'warm'],
        beach: ['citrus', 'bright'],
        cabin: ['woodsy', 'warm'],
        dinner: ['warm', 'romantic'],
        city: ['welcoming', 'bold'],
        mountains: ['woodsy', 'calm'],
        classic: ['balanced', 'warm'],
        minimalist: ['calm', 'soft'],
        bohemian: ['woodsy', 'floral'],
        sporty: ['citrus', 'bright'],
        trendy: ['bold', 'romantic']
      };
      const noteProfiles = {
        citrus: ['note-ruby-grapefruit', 'note-calabrian-bergamot', 'note-bergamot', 'note-lemon-zest', 'note-orange', 'note-citrus', 'note-pineapple'],
        warm: ['note-amber', 'note-vanilla', 'note-tonka-bean', 'note-sugar', 'note-caramel', 'note-cinnamon'],
        woodsy: ['note-woods', 'note-soft-woods', 'note-cedar', 'note-tuscan-cedar', 'note-driftwood', 'note-mahogany', 'note-oakmoss', 'note-vetiver', 'note-cypress'],
        floral: ['note-white-floral', 'note-jasmine', 'note-midnight-jasmine', 'note-heirloom-rose', 'note-lavender', 'note-lily-of-the-valley', 'note-freesia', 'note-vanilla-orchid'],
        seasonal: ['note-pumpkin', 'note-cider', 'note-red-apple', 'note-apple', 'note-cinnamon', 'note-clove', 'note-fir', 'note-berries'],
        soft: ['note-white-tea', 'note-cactus-water', 'note-lavender', 'note-sea-salt', 'note-green-leaves', 'note-powder'],
        balanced: ['note-bergamot', 'note-amber', 'note-wood', 'note-musk', 'note-vanilla'],
        bold: ['note-smoked-vanilla', 'note-tobacco-leaf', 'note-mahogany', 'note-spice', 'note-clove', 'note-dark-plum'],
        kitchen: ['note-lemon-zest', 'note-ruby-grapefruit', 'note-orange', 'note-mint', 'note-apple', 'note-red-apple', 'note-cider', 'note-cinnamon', 'note-pumpkin'],
        bedroom: ['note-lavender', 'note-jasmine', 'note-white-floral', 'note-heirloom-rose', 'note-vanilla', 'note-amber', 'note-white-musk'],
        living: ['note-amber', 'note-woods', 'note-cedar', 'note-vanilla', 'note-bergamot'],
        entry: ['note-tuscan-cedar', 'note-mahogany', 'note-tobacco-leaf', 'note-fir', 'note-cypress', 'note-driftwood'],
        gift: ['note-bergamot', 'note-amber', 'note-vanilla', 'note-white-tea'],
        spring: ['note-heirloom-rose', 'note-white-floral', 'note-lavender', 'note-green-stems', 'note-lemon-zest'],
        summer: ['note-ruby-grapefruit', 'note-mint', 'note-sea-salt', 'note-coconut', 'note-pineapple', 'note-mango', 'note-aquatic'],
        fall: ['note-pumpkin', 'note-cider', 'note-red-apple', 'note-apple', 'note-nutmeg', 'note-cinnamon', 'note-clove', 'note-mahogany'],
        winter: ['note-fir', 'note-cypress', 'note-eucalyptus', 'note-berries', 'note-clove', 'note-powder'],
        beach: ['note-sea-salt', 'note-marine', 'note-aquatic', 'note-coconut', 'note-driftwood'],
        cabin: ['note-cedar', 'note-tuscan-cedar', 'note-fir', 'note-cypress', 'note-woods', 'note-mahogany'],
        dinner: ['note-amber', 'note-vanilla', 'note-dark-plum', 'note-black-cherry', 'note-berries', 'note-tonka-bean'],
        city: ['note-bergamot', 'note-white-tea', 'note-amber', 'note-tobacco-leaf', 'note-smoked-vanilla'],
        mountains: ['note-fir', 'note-cypress', 'note-eucalyptus', 'note-vetiver', 'note-oakmoss', 'note-woods'],
        classic: ['note-bergamot', 'note-amber', 'note-vanilla', 'note-jasmine', 'note-cedar'],
        minimalist: ['note-white-tea', 'note-cactus-water', 'note-sea-salt', 'note-green-leaves', 'note-ozone'],
        bohemian: ['note-vetiver', 'note-oakmoss', 'note-woods', 'note-jasmine'],
        sporty: ['note-ruby-grapefruit', 'note-mint', 'note-ozone', 'note-marine'],
        trendy: ['note-dark-plum', 'note-black-cherry', 'note-smoked-vanilla', 'note-tobacco-leaf', 'note-cactus-water']
      };
      const products = Array.from(finder.querySelectorAll('[data-product]')).map((element) => {
        const tags = element.dataset.tags.split(' ');
        let score = tags.includes(answers.family) ? 3 : 0;
        score += tags.includes(answers.strength) ? 2 : 0;
        score += tags.includes(answers.room) ? 2 : 0;
        ['season', 'escape', 'style'].forEach((key) => {
          const matches = relatedTags[answers[key]] || [];
          score += matches.filter((tag) => tags.includes(tag)).length;
        });
        Object.values(answers).forEach((answer) => {
          const matchingNotes = noteProfiles[answer] || [];
          score += matchingNotes.filter((tag) => tags.includes(tag)).length * 0.35;
        });
        score += tags.includes('bestseller') ? 0.25 : 0;
        return { element, score, tags };
      });

      products.sort((a, b) => b.score - a.score);
      const profileTags = ['citrus', 'warm', 'woodsy', 'floral', 'seasonal', 'soft', 'balanced', 'bold'];
      const selectedProducts = products.length ? [products[0]] : [];
      while (selectedProducts.length < 3 && selectedProducts.length < products.length) {
        const remaining = products.filter((product) => !selectedProducts.includes(product));
        const bestRemainingScore = remaining[0].score;
        const relevantPool = remaining.filter((product) => product.score >= bestRemainingScore - 1.5);
        const usedProfiles = new Set(selectedProducts.flatMap((product) => product.tags.filter((tag) => profileTags.includes(tag))));
        relevantPool.sort((a, b) => {
          const diversityA = a.tags.filter((tag) => profileTags.includes(tag) && !usedProfiles.has(tag)).length;
          const diversityB = b.tags.filter((tag) => profileTags.includes(tag) && !usedProfiles.has(tag)).length;
          return diversityB - diversityA || b.score - a.score;
        });
        selectedProducts.push(relevantPool[0]);
      }

      currentMatches = selectedProducts.map(({ element }) => ({
        title: element.dataset.title.replace(/\s*9\s*oz\.?(?:\s*glass candle)?\s*$/i, '').trim(),
        url: new URL(element.dataset.url, window.location.origin).toString(),
        image: element.dataset.image,
        price: element.dataset.price
      }));
      sessionStorage.setItem('fmnQuizMatches', JSON.stringify(currentMatches));

      grid.replaceChildren();
      const cleanLabel = (value = '') => value.replace(/[\p{Extended_Pictographic}\uFE0F]/gu, '').replace(/\s+/g, ' ').trim();
      const naturalList = (items) => {
        if (items.length < 2) return items[0] || '';
        if (items.length === 2) return `${items[0]} + ${items[1]}`;
        return `${items.slice(0, -1).join(', ')} + ${items.at(-1)}`;
      };
      const roleLabel = (product, index) => {
        if (index === 0) return finder.dataset.primaryMatch;
        if (answers.strength !== 'soft' && product.tags.includes('soft')) return 'A softer take';
        if (answers.strength !== 'bold' && product.tags.includes('bold')) return 'A bolder take';
        return index === 1 ? 'A fresh perspective' : finder.dataset.secondaryMatch;
      };

      selectedProducts.forEach(({ element, tags }, index) => {
        const card = resultTemplate.content.cloneNode(true);
        const link = card.querySelector('[data-product-link]');
        const image = card.querySelector('[data-product-image]');
        const title = currentMatches[index].title;
        const notes = tags
          .filter((tag) => tag.startsWith('note-'))
          .slice(0, 3)
          .map((tag) => tag.replace('note-', '').replaceAll('-', ' '));
        link.href = element.dataset.url;
        link.addEventListener('click', () => track('product_clicked', { product: title, position: index + 1 }));
        image.src = element.dataset.image;
        image.alt = element.dataset.title;
        card.querySelector('[data-product-rank]').textContent = roleLabel({ tags }, index);
        card.querySelector('[data-product-title]').textContent = title;
        card.querySelector('[data-product-reason]').textContent = `${cleanLabel(answerLabels.family)} · ${naturalList(notes)}`;
        card.querySelector('[data-product-price]').textContent = element.dataset.price;
        grid.append(card);
      });

      const bundleLink = finder.querySelector('[data-bundle-link]');
      if (bundleLink && currentMatches.length) {
        const bundleUrl = new URL(bundleLink.href, window.location.origin);
        currentMatches.forEach((match, index) => bundleUrl.searchParams.set(`match${index + 1}`, match.title));
        bundleLink.href = bundleUrl.toString();
      }

      track('completed', {
        answers: { ...answers },
        matches: currentMatches.map((match) => match.title)
      });

      summary.textContent = finder.dataset.resultsSummaryText;
      transition(() => {
        loading.hidden = true;
        results.hidden = false;
      });
      results.querySelector('h2').focus({ preventScroll: true });
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    form.addEventListener('click', (event) => {
      const back = event.target.closest('[data-back]');
      if (back) {
        showStep(Math.max(currentStep - 1, 0));
        return;
      }
      const button = event.target.closest('[data-answer]');
      if (!button) return;
      const [category, value] = button.dataset.answer.split(':');
      answers[category] = value;
      answerLabels[category] = button.textContent.trim();
      track('answer_selected', { step: currentStep + 1, category, value });
      if (currentStep < steps.length - 1) {
        showStep(currentStep + 1);
      } else {
        transition(() => {
          quizShell.hidden = true;
          loading.hidden = false;
        });
        window.setTimeout(showResults, 850);
      }
    });

    finder.querySelector('[data-start]').addEventListener('click', () => {
      track('started');
      transition(() => {
        intro.hidden = true;
        quizShell.hidden = false;
      });
      showStep(0);
    });

    finder.querySelector('[data-bundle-link]')?.addEventListener('click', () => {
      track('bundle_clicked', { matches: currentMatches.map((match) => match.title), savings: 11 });
    });

    emailResultsForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const input = emailResultsForm.elements.email;
      const button = emailResultsForm.querySelector('button[type="submit"]');
      const email = input.value.trim().toLowerCase();

      emailStatus.textContent = '';
      emailStatus.removeAttribute('data-state');
      if (!email || !input.checkValidity()) {
        input.focus();
        emailStatus.textContent = 'Please enter a valid email address.';
        emailStatus.dataset.state = 'error';
        return;
      }

      button.disabled = true;
      button.textContent = 'SENDING…';
      const answerDetails = Object.fromEntries(
        Object.entries(answers).map(([key, value]) => [key, {
          value,
          label: (answerLabels[key] || value).replace(/[\p{Extended_Pictographic}\uFE0F]/gu, '').replace(/\s+/g, ' ').trim()
        }])
      );

      const eventPayload = {
        data: {
          type: 'event',
          attributes: {
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Scent Quiz Results Requested' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: {
                    scent_quiz_last_completed: new Date().toISOString(),
                    scent_quiz_primary_match: currentMatches[0]?.title || ''
                  }
                }
              }
            },
            properties: {
              source: 'FMN Candle Finder',
              answers: answerDetails,
              matches: currentMatches,
              primary_match: currentMatches[0] || null,
              second_match: currentMatches[1] || null,
              third_match: currentMatches[2] || null,
              bundle_url: finder.querySelector('[data-bundle-link]')?.href || ''
            },
            time: new Date().toISOString()
          }
        }
      };

      try {
        /*const response = await fetch('https://a.klaviyo.com/client/events/?company_id=T6YNra', {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(eventPayload)
        });
        if (!response.ok) throw new Error(`Klaviyo returned ${response.status}`);*/
await new Promise((resolve, reject) => {
  const request = new XMLHttpRequest();
  request.open('POST', 'https://a.klaviyo.com/client/events/?company_id=T6YNra');
  request.setRequestHeader('accept', 'application/vnd.api+json');
  request.setRequestHeader('content-type', 'application/vnd.api+json');
  request.setRequestHeader('revision', '2026-07-15');
  request.onload = () => {
    if (request.status >= 200 && request.status < 300) {
      resolve();
      return;
    }
    reject(new Error(`Klaviyo returned ${request.status}`));
  };
  request.onerror = () => reject(new Error('Klaviyo request failed'));
  request.send(JSON.stringify(eventPayload));
});
        track('results_emailed', {
          matches: currentMatches.map((match) => match.title)
        });
        emailStatus.textContent = 'Done—your scent edit is on its way.';
        emailStatus.dataset.state = 'success';
        input.value = '';
        button.textContent = 'EMAIL SENT';
      } catch (error) {
        console.error('Unable to email scent quiz results.', error);
        emailStatus.textContent = 'We could not send that yet. Please try again.';
        emailStatus.dataset.state = 'error';
        button.disabled = false;
        button.textContent = 'EMAIL MY MATCHES';
      }
    });

    finder.querySelector('[data-restart]').addEventListener('click', () => {
      track('restarted');
      Object.keys(answers).forEach((key) => delete answers[key]);
      Object.keys(answerLabels).forEach((key) => delete answerLabels[key]);
      results.hidden = true;
      intro.hidden = false;
      quizShell.hidden = true;
      finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
